import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '@/api/util'
import { Api, Spotted, Common } from '@cruz-com/lookup'

export const spotted = {
  getMySpotted,
  postSpotted,
  deleteSpotted,
  undeleteSpotted,
  sortPhotos,
  deletePhotos
}

async function getMySpotted(params: object): Promise<Api.Result<Spotted.Summary>> {
  try {
    const res = await fetch(`${baseURL}/my/spotted?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 0 },
      cache: 'no-store'
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}


// post is for both create & update
async function postSpotted(formData: FormData): Promise<Api.Result<Spotted.Detail>> {
  try {
    const res = await fetch(`${baseURL}/spotted`, {
      method: 'POST',
      headers: await fetchHeaders(true),
      body: formData,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// delete
async function deleteSpotted(id: string): Promise<Api.Result<Spotted.Detail>> {
  try {
    const res = await fetch(`${baseURL}/spotted/${id}`, {
      method: 'DELETE',
      headers: await fetchHeaders(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// undelete
async function undeleteSpotted(id: string): Promise<Api.Result<Spotted.Detail>> {
  try {
    const res = await fetch(`${baseURL}/spotted/${id}/undelete`, {
      method: 'PATCH',
      headers: await fetchHeaders(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// sort photos
export async function sortPhotos(id: string, photo_list: Common.Photo[]): Promise<Api.Result<Spotted.Detail>> {
  try {
    const res = await fetch(`${baseURL}/spotted/${id}/sort-photos`, {
      method: 'PATCH',
      headers: await fetchHeaders(),
      body: JSON.stringify({ photo_list })
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// delete spotted photos
export async function deletePhotos(id: string, photo_list: Common.Photo[]): Promise<Api.Result<Spotted.Detail>> {
  try {
    const res = await fetch(`${baseURL}/spotted/${id}/photos`, {
      method: 'DELETE',
      headers: await fetchHeaders(),
      body: JSON.stringify({ photo_list })
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}